module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_5-e629c44fcc67ae314f2c7d162ff98b62.png";